export { default as createReducer } from './createReducer'
export { default as urlResource } from './urlResource'
export { default as withUrlResource } from './withUrlResource'
export { default as withUrlResourceTimezone } from './withUrlResourceTimezone'

export const userFullname = user =>
  user.last_name ? `${user.first_name} ${user.last_name}` : user.first_name
